const MESES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

export function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso.length === 10 ? iso + "T12:00:00" : iso);
  if (isNaN(d)) return "—";
  return `${String(d.getDate()).padStart(2, "0")}/${MESES[d.getMonth()]}/${d.getFullYear()}`;
}

export function fmtMoney(n) {
  if (!n) return "—";
  return new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN", maximumFractionDigits: 0 }).format(n);
}

export function fmtNum(n) {
  return new Intl.NumberFormat("es-MX").format(n);
}

export const ESTATUS_TRAMITE = ["No iniciado", "En preparación", "Ingresado a autoridad",
  "En prevención/subsanación", "Aprobado", "Rechazado", "Vencido", "No aplica"];

export const TRAMITE_STYLE = {
  "No iniciado": { bg: "bg-slate-100", text: "text-slate-600", dot: "#94A3B8" },
  "En preparación": { bg: "bg-sky-50", text: "text-sky-700", dot: "#0284C7" },
  "Ingresado a autoridad": { bg: "bg-cyan-50", text: "text-cyan-700", dot: "#00A3B5" },
  "En prevención/subsanación": { bg: "bg-amber-50", text: "text-amber-700", dot: "#D97706" },
  "Aprobado": { bg: "bg-emerald-50", text: "text-emerald-700", dot: "#059669" },
  "Rechazado": { bg: "bg-red-50", text: "text-red-700", dot: "#DC2626" },
  "Vencido": { bg: "bg-red-100", text: "text-red-800", dot: "#991B1B" },
  "No aplica": { bg: "bg-slate-50", text: "text-slate-400", dot: "#CBD5E1" },
};

export const ESTATUS_UPE = ["Fase futura", "Sin iniciar", "En tramitología", "En permisología",
  "Permisos completos — lista para construir", "Bloqueada / con observaciones"];

export const UPE_COLORS = {
  "Fase futura": "#E2E8F0",
  "Sin iniciar": "#CBD5E1",
  "En tramitología": "#FACC15",
  "En permisología": "#FB923C",
  "Permisos completos — lista para construir": "#34D399",
  "Bloqueada / con observaciones": "#F87171",
};

export const USOS = ["Hotel", "Condominio", "Hotel-Condominio", "Parque Acuático", "Comercial", "Área Común", "Residencial", "Mixto", "Otro"];

export const USO_STROKE = {
  "Hotel": "#BE185D", "Condominio": "#7C3AED", "Hotel-Condominio": "#0369A1",
  "Parque Acuático": "#EA580C", "Comercial": "#4338CA", "Área Común": "#15803D",
  "Residencial": "#0E7490", "Mixto": "#A16207", "Otro": "#64748B",
};

export function imgUrl(fname) {
  return fname ? `${process.env.REACT_APP_BACKEND_URL}/api/img/${fname}` : null;
}

export const LOGIN_HERO = "https://images.unsplash.com/photo-1551128997-c2b66772f982?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxhcmNoaXRlY3R1cmUlMjBkdXNrfGVufDB8fHxibHVlfDE3ODcxODE2OTN8MA&ixlib=rb-4.1.0&q=85";

export const PLACEHOLDER_IMGS = [
  "https://images.unsplash.com/photo-1764258777856-723351e71a17?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjBza3lsaW5lfGVufDB8fHx8MTc4NzE4MTY5M3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1508885368104-a4871600f1e0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHxyZWFsJTIwZXN0YXRlJTIwYWVyaWFsfGVufDB8fHx8MTc4NzE4MTY5M3ww&ixlib=rb-4.1.0&q=85",
];

export const PRIORIDAD_STYLE = {
  Alta: "bg-red-50 text-red-700 border-red-200",
  Media: "bg-amber-50 text-amber-700 border-amber-200",
  Baja: "bg-slate-50 text-slate-600 border-slate-200",
};

export const ROLE_LABEL = { admin: "Administrador", gestor: "Gestor", financiero: "Financiero", consulta: "Consulta" };

export const TAREA_ESTATUS = ["Pendiente", "En curso", "En espera de tercero", "Cerrada", "Cancelada"];
export const SEMAFORO_COLOR = { rojo: "#DC2626", amarillo: "#D97706", verde: "#059669", gris: "#94A3B8" };
export const PRODUCTO_ESTATUS = ["Idea", "En definición", "Aprobado por dirección", "Aprobado por la marca", "Congelado para proyecto ejecutivo"];
export const PRODUCTO_COLORS = {
  "Idea": "#CBD5E1", "En definición": "#FACC15", "Aprobado por dirección": "#60A5FA",
  "Aprobado por la marca": "#34D399", "Congelado para proyecto ejecutivo": "#C084FC",
};
export const CREDITO_ESTATUS = ["En negociación", "Term sheet firmado", "En condiciones precedentes",
  "Vigente/Disponiendo", "En amortización", "Liquidado", "En incumplimiento"];
export const CONTACTO_TIPOS = ["Gestor", "Autoridad", "Consultor", "Notaría", "Banco", "Operador-Marca", "Otro"];
export const CAL_COLORS = {
  tarea: "#00A3B5", acuerdo: "#7C3AED", cita: "#0284C7", hito: "#059669",
  vencimiento_permiso: "#DC2626", compromiso_tramite: "#D97706", pago_credito: "#BE185D", covenant: "#EA580C",
};
export const CAL_LABELS = {
  tarea: "Tarea", acuerdo: "Acuerdo", cita: "Cita", hito: "Hito",
  vencimiento_permiso: "Vence permiso", compromiso_tramite: "Compromiso trámite", pago_credito: "Pago crédito", covenant: "Covenant",
};

export function fmtMoneyCur(n, cur = "MXN") {
  if (n == null) return "—";
  return new Intl.NumberFormat("es-MX", { style: "currency", currency: cur === "USD" ? "USD" : "MXN", maximumFractionDigits: 0 }).format(n);
}
